export const USER_ID_HEADER = "user-id";
export const FILE_IDS = "file-ids";